module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/callouts/callout-style1/callout-style1.component.scss
// module id = ./src/app/callouts/callout-style1/callout-style1.component.scss
// module chunks = main